export const PHASE_DELETE_PHASE_BEGIN = 'PHASE_DELETE_PHASE_BEGIN';
export const PHASE_DELETE_PHASE_SUCCESS = 'PHASE_DELETE_PHASE_SUCCESS';
export const PHASE_DELETE_PHASE_FAILURE = 'PHASE_DELETE_PHASE_FAILURE';
export const PHASE_DELETE_PHASE_DISMISS_ERROR = 'PHASE_DELETE_PHASE_DISMISS_ERROR';
export const PHASE_SAVE_PHASE_BEGIN = 'PHASE_SAVE_PHASE_BEGIN';
export const PHASE_SAVE_PHASE_SUCCESS = 'PHASE_SAVE_PHASE_SUCCESS';
export const PHASE_SAVE_PHASE_FAILURE = 'PHASE_SAVE_PHASE_FAILURE';
export const PHASE_SAVE_PHASE_DISMISS_ERROR = 'PHASE_SAVE_PHASE_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/phase/redux/constants.js